import { combineReducers } from "redux";
import c from "./constant";

function items(state = [], action) {
  switch (action.type) {
    case c.SET_DEDUCTIONS:
      return action.deductions;
    case c.CLEAR_DEDUCTIONS:
      return [];
    default:
      return state;
  }
}

export default combineReducers({ items });
